export default __webpack_public_path__ + "static/media/kitchen3-afterH-1440w.df946dcf.avif";